import Vue from 'vue';
import App from '@/App';

import router from '@/router'
import store from '@/store'

import '@/assets/css/common.scss'


// 引入框架代码
import { initApp } from '@/framework/index'
const baseApp = initApp({
  router,
  store
})

new Vue({
  mixins: [ baseApp ],
  render: h => h(App)
})
